import { AnswerTypes } from '../../enums';
import Radio from './Radio/Radio';
import NullableTextbox from './NullableTextbox/NullableTextbox';

export const answerMap = {
  [AnswerTypes.RADIO]: Radio,
  [AnswerTypes.NULLABLETEXTBOX]: NullableTextbox,
};
